// @flow

import { useCallback } from 'react';
import { useTenant } from '@tectonics/commons/tenant';
import { usePayment } from '../context';
import { collectRiskSignals } from '../../pix-jsr-enrollment/hooks/use-risk-signals';
import { authenticatePayment } from '../services/payment-api';
import type { AssertionResponse } from '../services/webauthn';

export function usePaymentAuthentication(): (assertionData: AssertionResponse) => Promise<void> {
  const tenant = useTenant();
  const { data, dispatch } = usePayment();

  return useCallback(async (assertionData: AssertionResponse) => {
    dispatch({ type: 'START_SUBMITTING_AUTH' });

    try {
      const riskSignals = collectRiskSignals();
      const response = await authenticatePayment(
        data.paymentHash,
        assertionData,
        riskSignals,
        tenant.code,
      );

      if (response.status === 'SUCCESS') {
        dispatch({ type: 'AUTH_SUBMITTED' });
      } else {
        dispatch({
          type: 'SET_ERROR',
          errorMessage: response.status_message || 'Falha na autenticação do pagamento.',
        });
      }
    } catch (err) {
      dispatch({ type: 'SET_ERROR', errorMessage: err.message || 'Falha na autenticação do pagamento.' });
    }
  }, [data.paymentHash, tenant.code, dispatch]);
}
